/**
 * Welches Avamo-Büro das Projekt angelegt hat (User-Land D oder I) – nicht der Projektstandort.
 * Excel: COUNTRY OF QUOTATION.
 */
export const QUOTATION_COUNTRIES = [
  { value: 'D', label: 'Deutschland' },
  { value: 'I', label: 'Italien' }
] as const;

export type QuotationCountry = typeof QUOTATION_COUNTRIES[number]['value'];

export const isQuotationCountry = (value: unknown): value is QuotationCountry =>
  QUOTATION_COUNTRIES.some((country) => country.value === value);

export const quotationCountryLabel = (value?: string | null): string =>
  QUOTATION_COUNTRIES.find((country) => country.value === value)?.label ?? '';

/** Compact table code: D → DE, I → IT */
export const quotationCountryCode = (value?: string | null): string => {
  if (value === 'D') {
    return 'DE';
  }
  if (value === 'I') {
    return 'IT';
  }
  return '';
};

export const quotationCountryItems = QUOTATION_COUNTRIES.map((country) => ({
  text: `${country.value} – ${country.label}`,
  value: country.value
}));

/** Tabellenkopf: kurz, weil nur D oder I angezeigt wird */
export const quotationCountryTableHeader = 'Angelegt über (DE/IT)';

/** Formular / Eckdaten */
export const quotationCountryFieldLabel = 'Angelegt über (Deutschland / Italien)';
